(function () {
  function norm(s){ return String(s||'').toLowerCase().replace(/\s+/g,'').trim(); }
  function getOptionFieldset(name){
    const wanted = norm(name);
    const sets = Array.from(document.querySelectorAll('fieldset'));
    return sets.find(fs=>{
      const label = fs.getAttribute('name')
        || fs.getAttribute('data-option-name')
        || fs.querySelector('legend')?.textContent
        || '';
      return norm(label) === wanted;
    }) || null;
  }
  function clickRadioByValue(fieldset, value){
    if (!fieldset) return false;
    const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
    const target = radios.find(r => r.value.toLowerCase() === value.toLowerCase() && !r.disabled);
    if (target && !target.checked) {
      target.click();
      target.dispatchEvent(new Event('change', {bubbles:true}));
      return true;
    }
    return !!target && target.checked;
  }
  function clickFirstAvailableColor(fieldset){
    if (!fieldset) return false;
    const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
    const first = radios.find(r => r.value.toLowerCase() !== 'no frame' && !r.disabled);
    if (first && !first.checked) {
      first.click();
      first.dispatchEvent(new Event('change', {bubbles:true}));
      return true;
    }
    return !!first && first.checked;
  }
  function syncFrameWithStyle(styleValue){
    const style = String(styleValue||'').toLowerCase();
    const frameFs = getOptionFieldset('Outer Frame Color');
    if (!frameFs) return;
    if (style.includes('framed')) {
      const ok = clickRadioByValue(frameFs, 'Black'); // хочешь — замени на 'White'
      if (!ok) clickFirstAvailableColor(frameFs);
    } else {
      clickRadioByValue(frameFs, 'No Frame');
    }
  }
  document.addEventListener('change', function(e){
    const el = e.target;
    if (!(el && el.name && el.name.toLowerCase().includes('options['))) return;
    if (!el.name.toLowerCase().includes('options[style]')) return;
    const value = (el.type === 'radio' || el.type === 'checkbox')
      ? el.value
      : el.options?.[el.selectedIndex]?.value;
    syncFrameWithStyle(value);
  }, {passive:true});
  window.addEventListener('load', function(){
    const fs = getOptionFieldset('Style');
    if (!fs) return;
    const checked = fs.querySelector('input[type="radio"]:checked');
    const select = fs.querySelector('select');
    const curr = checked?.value || select?.options?.[select.selectedIndex]?.value;
    if (curr) syncFrameWithStyle(curr);
  });
})();
